import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  InputAdornment,
  InputBase,
  Button,
  Link,
  Dialog,
  DialogContent,
  DialogActions,
  makeStyles,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { CloudUpload } from "@material-ui/icons";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DataService from "../../../../Service";
import { ObjectToFormdata } from "../../../../Common/Utils/common_utils";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularIndeterminate from "../../../../Components/Loader";
import image_icon from "../../../../Images/image_icon.png";
import pdf_icon from "../../../../Images/pdf_icon.png";
import doc_icon from "../../../../Images/doc_icon.png";
import moment from "moment";

function Document(props) {
  const classes = useStyles();
  const [docData, setDocData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmationDialogOpen, setConfirmationDialogOpen] =
    React.useState(false);
  const [currentID, setcurrentID] = React.useState(0);
  const [searchData, setSearchData] = React.useState("");

  const handleClickConfirmationOpen = () => {
    setConfirmationDialogOpen(true);
  };

  const handleConfirmationClose = () => {
    setConfirmationDialogOpen(false);
  };

  const getDocument = (params) => {
    // setLoading(true);
    DataService.getDirectData("employee_personal_documents", params)
      .then((res) => {
        // setLoading(false);
        docData.length = 0;
        setDocData(docData.concat(res.employee_personal_document));
      })
      .catch((err) => {
        // setLoading(false);
      });
  };
  const uploadDoc = (event, id) => {
    setLoading(true);
    var postData = {
      employee_id: props.id,
      document: event.target.files[0],
      document_type: "pdf",
    };
    DataService.createData(
      ObjectToFormdata({ ...postData }),
      "employee_personal_documents"
    )
      .then((response) => {
        setLoading(false);
        var localArr = [];
        localArr.push(response.employee_personal_document);
        setDocData(docData.concat(localArr));
      })
      .catch(() => {});
  };

  const deleteDoc = (id) => {
    setLoading(true);
    DataService.deleteDirectFeild("employee_personal_documents/" + id, {})
      .then((response) => {
        setLoading(false);
        var localArr = docData.filter((option) => option.id != id);
        docData.length = 0;
        setDocData(docData.concat(localArr));
      })
      .catch(() => {});
  };

  useEffect(() => {
    getDocument({ search: searchData });
  }, [searchData]);

  return (
    <Box p={3} alignItems="center">
      <Box>
        <Grid
          container
          direction="row"
          alignItems="center"
          style={{ padding: "20px" }}
        >
          <Grid item xs={6}>
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.75rem",
                alignItems: "flex-start",
              }}
            >
              <Typography variant="h1">
                <Box fontWeight="fontWeightBold" color={"#077F83"}>
                  Documents
                </Box>
              </Typography>

              <InputBase
                fullWidth
                style={{
                  // padding: "5px 5px",
                  // paddingBlock: 4,
                  maxWidth: "17rem",
                  paddingLeft: "0.75rem",
                  paddingRight: "0.75rem",
                  borderWidth: 1,
                  borderStyle: "solid",
                  borderRadius: "0.25rem",
                  color: "black",
                  borderColor: "#D0D0D0",
                  fontSize: "16px",
                  height: "2.75rem",
                }}
                placeholder={"Search documents"}
                value={searchData}
                onChange={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setSearchData(e.target.value);
                }}
                inputProps={{
                  style: {
                    marginTop: "0.25rem",
                    marginLeft: "0.15rem",
                  },
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <label
              htmlFor="upload-photo-passport"
              style={{ marginRight: "2rem" }}
            >
              <input
                onChange={(e) => {
                  uploadDoc(e);
                }}
                accept="application/pdf, application/vnd.ms-excel,image/gif, image/jpeg"
                style={{ display: "none" }}
                id="upload-photo-passport"
                name="upload-photo"
                type="file"
              />
              <Button
                disableElevation
                color="secondary"
                variant="contained"
                component="span"
                style={{
                  fontSize: 12,
                  padding: "10px 24px",
                  textTransform: "none",
                }}
              >
                <CloudUpload style={{ marginRight: 10, height: "22px" }} />
                Upload
              </Button>
            </label>
          </Grid>
        </Grid>
      </Box>
      <Box mt={5} style={{ border: "1px solid #dddddd" }}>
        <Grid container direction="row" alignItem="center">
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              alignItem="center"
              style={{
                color: "#077F83",
                borderBottom: "1px solid #dddddd",
                padding: "10px 20px",
              }}
            >
              <Grid item xs={5}>
                <Typography variant="subtitle1">
                  <Box mb={3} fontWeight="fontWeightBold" style={{ margin: 0 }}>
                    Document Name
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle1">
                  <Box mb={3} fontWeight="fontWeightBold" style={{ margin: 0 }}>
                    Added by
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle1">
                  <Box mb={3} fontWeight="fontWeightBold" style={{ margin: 0 }}>
                    Last edit details
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ padding: "15px 20px 0px 20px" }}>
            {docData.length ? (
              docData.map((option) => {
                return (
                  <Grid
                    key={option.id}
                    container
                    direction="row"
                    // spacing={2}
                    alignItem="center"
                  >
                    <Grid item xs={5} style={{ paddingRight: "0.75rem" }}>
                      <Link href={option.document.url} target="_blank">
                        <Grid container direction="row" alignItem="center">
                          <Grid item xs={1}>
                            {option.file_name.replace(/^.*\./, "") == "pdf" ? (
                              <Box alignItems="start">
                                <img
                                  src={pdf_icon}
                                  alt="Acuity"
                                  className={classes.pdf_icon}
                                  onClick={() => {}}
                                />
                              </Box>
                            ) : option.file_name.replace(/^.*\./, "") ==
                              "doc" ? (
                              <Box alignItems="start">
                                <img
                                  src={doc_icon}
                                  alt="Acuity"
                                  className={classes.doc_icon}
                                  onClick={() => {}}
                                />
                              </Box>
                            ) : (
                              <Box alignItems="start">
                                <img
                                  src={image_icon}
                                  alt="Acuity"
                                  className={classes.image_icon}
                                  onClick={() => {}}
                                />
                              </Box>
                            )}
                          </Grid>
                          <Grid item xs={11}>
                            <Typography
                              variant="h2"
                              style={{
                                width: "100%",
                                wordWrap: "break-word",
                                color: "#000",
                              }}
                            >
                              {option.file_name}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Link>
                    </Grid>
                    <Grid item xs={3} style={{ padding: "8px 0" }}>
                      <Typography variant="h2" style={{ color: "#000" }}>
                        <Box mb={3}>{option.employee_name}</Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={3} style={{ padding: "8px 0" }}>
                      <Typography variant="h2" style={{ color: "#000" }}>
                        <Box mb={3}>
                          {moment(option.updated_at).format("DD/MM/YYYY HH:MM")}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Box>
                        <DeleteIcon
                          onClick={() => {
                            setcurrentID(option.id);
                            handleClickConfirmationOpen();
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                );
              })
            ) : (
              <Grid container direction="row">
                <Grid xs={12} item>
                  <Typography variant="subtitle1" style={{ color: "#000" }}>
                    <Box mb={3}>No documents found</Box>
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Dialog
          onClose={handleConfirmationClose}
          aria-labelledby="confirmation-dialog-title"
          open={confirmationDialogOpen}
        >
          <DialogContent>
            <Box py={4} px={8}>
              <Typography variant="h2">
                <Box textAlign="center">Are you sure to delete?</Box>
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions
            disableSpacing={true}
            style={{ justifyContent: "center" }}
          >
            <Box px={4} pb={2}>
              <Button
                disableElevation
                variant="contained"
                onClick={handleConfirmationClose}
              >
                No
              </Button>
              <Button
                disableElevation
                variant="contained"
                color="secondary"
                onClick={() => {
                  handleConfirmationClose();
                  deleteDoc(currentID);
                }}
                style={{ marginLeft: 10 }}
              >
                Yes
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
      {loading && <CircularIndeterminate />}
    </Box>
  );
}

export default Document;
const useStyles = makeStyles((theme) => ({
  doc_icon: { width: 16 },
  image_icon: { width: 25 },
  pdf_icon: { width: 17 },
}));
